import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { NotificationProvider } from './context/NotificationContext'
import PrivateRoute from './components/common/PrivateRoute'
import Layout from './components/layout/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Services from './pages/Services'
import Blog from './pages/Blog'
import BlogForm from './pages/BlogForm'
import Gallery from './pages/Gallery'
import Testimonials from './pages/Testimonials'
import Appointments from './pages/Appointments'
import Contacts from './pages/Contacts'
import Settings from './pages/Settings'
import NavbarPages from './pages/NavbarPages'
import Carousel from './pages/Carousel'
import Offers from './pages/Offers'
import About from './pages/About'
import AllServices from './pages/AllServices'
import Account from './pages/Account'

function App() {
  return (
    <Router>
      <AuthProvider>
        <NotificationProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/admin" replace />} />
            <Route
              path="/admin/*"
              element={
                <PrivateRoute>
                  <Layout>
                    <Routes>
                      <Route index element={<Dashboard />} />
                      <Route path="dashboard" element={<Dashboard />} />
                      <Route path="services" element={<Services />} />
                      <Route path="blog" element={<Blog />} />
                      <Route path="blog/new" element={<BlogForm />} />
                      <Route path="blog/:id/edit" element={<BlogForm />} />
                      <Route path="gallery" element={<Gallery />} />
                      <Route path="testimonials" element={<Testimonials />} />
                      <Route path="appointments" element={<Appointments />} />
                      <Route path="contacts" element={<Contacts />} />
                      <Route path="settings" element={<Settings />} />
                      <Route path="nav" element={<NavbarPages />} />
                      <Route path="carousel" element={<Carousel />} />
                      <Route path="offers" element={<Offers />} />
                      <Route path="about" element={<About />} />
                      <Route path="all-services" element={<AllServices />} />
                      <Route path="account" element={<Account />} />
                    </Routes>
                  </Layout>
                </PrivateRoute>
              }
            />
          </Routes>
        </NotificationProvider>
      </AuthProvider>
    </Router>
  )
}

export default App
